<template>
  <div class="">
    <div v-for="(item, i) in list" :key="i" @contextmenu="show">
      <IntervalIOReportListMobItem :item="item" />
    </div>
    <IOContextMenu :showMenu="showMenu" :x="x" :y="y" />
  </div>
</template>

<script>
import IOContextMenu from '../../widget/IOContextMenu.vue';
import IntervalIOReportListMobItem from './IntervalIOReportListMobItem.vue';
export default {
  components: { IntervalIOReportListMobItem, IOContextMenu },
  props: {
    list: Array,
  },
  computed: {},
  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
    };
  },
  methods: {
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
  },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>